/**
 * @prettier
 * @flow
 */
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { App } from 'src/App';

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#2F4050',
        },
        secondary: {
            main: '#1AB393',
        },
    },
});

export function AppRoot() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    );
}
